export const enableCustomConfigBranding = (brandingObj, clientappCustomBranding, myCustomTheme) => {
  const keys = Object.keys(clientappCustomBranding);
  const brandingObjKeys = Object.keys(brandingObj);
  let list = keys.filter(item => {
    return item.match(/^aas/g);
  });
  list.forEach(item => {
    const value = clientappCustomBranding[item];
    if (value.match(/^#/)) {
      myCustomTheme[item] = value;
    } else if (brandingObjKeys.includes(value)) {
      myCustomTheme[item] = brandingObj[value];
    }
  });
  return myCustomTheme;
};